import store from "@/core/store";
import storage from "@/core/services/storage.service";

export default function guest({next, router}) {
    if (store.getters.isAuthenticated) {
        return router.push({name: 'home'}).catch(() => {
        });
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has('redirect') && urlParams.get('redirect').startsWith('https://')) {
        const redirectParam = urlParams.get('redirect');
        storage.local().set('redirect', redirectParam)
    }
    return next();
}
